/**
 * Reads the queue price input. A blank price matches the field, which shows $1.
 * @param {unknown} price
 * @returns {number}
 */
export function readItemPrice(price) {
    if (price == null || price === '') return 1;
    const amount = Number(price);
    return Number.isFinite(amount) ? amount : 1;
}

/**
 * Sums each item's queue price into the lot price string.
 * @param {Array<{ price?: unknown }>} items
 * @returns {string}
 */
export function sumItemPrices(items) {
    const cents = (items ?? []).reduce(
        (total, item) => total + Math.round(readItemPrice(item?.price) * 100),
        0
    );
    return (cents / 100).toFixed(2);
}

/**
 * Sums stored list prices. A missing price counts as $0.
 * eBay rows that display a blank price as $1 should use sumItemPrices.
 * @param {Array<{ price?: unknown }>} items
 * @returns {number}
 */
export function sumStoredListPrices(items) {
    const cents = (items ?? []).reduce((total, item) => {
        const raw = item?.price;
        if (raw == null || raw === '') return total;
        const amount = Number(raw);
        if (!Number.isFinite(amount)) return total;
        return total + Math.round(amount * 100);
    }, 0);
    return cents / 100;
}
